export const OPERATIONS = {
  CAN_ACCESS_JARVIS_PORTAL: 'CanAccess_JarvisRatingPortal',
} as const;
